import actualizarProgresoTemas
from "./actualizarProgresoTemas";
import {
	doc,
	getDoc,
	setDoc,
	collection,
	getDocs
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import {
	calcularRango,
	calcularCorrupcion
} from "./progresoEngine";

import { ACHIEVEMENTS } from "./achievements";
import { DAILY_QUESTS } from "./dailyQuests";

import {
	GAME_BALANCE,
	STREAK_MULTIPLIERS
} from "./gameBalance";

import {
	calcularRanked
} from "./rankedSystem";
import {
	auth
} from "../firebase/firebaseConfig";

const calcularXpNecesaria = (nivel) => {

	return Math.round(100 * Math.pow(nivel, 1.2));
};

const actualizarProgresoMeta = async ({
	userId,
	metaId,
	correcta,
	pregunta
}) => {

	console.log(
		"ENTRANDO actualizarProgresoMeta"
	);
	
	console.log({
		userId,
		metaId,
		correcta,
		pregunta
	});
	try {

		const ref = doc(
			db,
			"progreso_metas",
			`${userId}_${metaId}`
		);

		const snap = await getDoc(ref);

		let data = {
			userName:
				auth.currentUser?.displayName ||
				auth.currentUser?.email ||
				"Jugador",
			userId,
			seasonHistory: [],
			yutokens: 0,
			inventario: [],
			tituloActivo: null,
			metaId,
			preguntas_respondidas: 0,
			preguntas_correctas: 0,
			nivel: 1,
			xp: 0,
			rankedLp: 0,
			rankedRango: "Hierro",
			xp_siguiente_nivel: 100,
			rango: "Iniciado",
			corrupcion: 0,
			streak_actual: 0,
			mejor_streak: 0,
			dailyQuests: {},
			ultimaResetDaily:
			new Date().toDateString(),
			achievements: [],
			materiasStats: {}
		};

		if (snap.exists()) {

			data = snap.data();
		}

		const hoy = new Date().toDateString();

		if (data.ultimaResetDaily !== hoy) {

			data.dailyQuests = {};

			data.ultimaResetDaily = hoy;
		}

		data.preguntas_respondidas += 1;

		let materia = "General";

		try {

			const temaId = Number(
				pregunta?.Tema1
			);

			if (temaId) {

				const temasSnap = await getDocs(
					collection(db, "materias_temas")
				);

				const temas = temasSnap.docs.map(
					(doc) => doc.data()
				);

				const temaEncontrado = temas.find(
					(t) => Number(t.ID) === temaId
				);

				if (temaEncontrado?.Materia) {

					materia =
						temaEncontrado.Materia;
				}
			}

		} catch (err) {

			console.error(
				"Error obteniendo materia:",
				err
			);
		}

		let config;

		if (correcta === true) {
		
			config = GAME_BALANCE.correcta;
		
			data.preguntas_correctas += 1;
		
			data.streak_actual =
				(data.streak_actual || 0) + 1;
		
		} else if (correcta === false) {
		
			config = GAME_BALANCE.incorrecta;
		
			data.streak_actual = 0;
		
		} else {
		
			config = GAME_BALANCE.noEntiendo;
		
			data.streak_actual =
				data.streak_actual || 0;
		}
		
		data.mejor_streak = Math.max(
			data.mejor_streak || 0,
			data.streak_actual
		);
		
		let multiplier = 1;

		Object.entries(STREAK_MULTIPLIERS)
			.forEach(([streak, multi]) => {

				if (data.streak_actual >= Number(streak)) {
					multiplier = multi;
				}
			});

			const xpFinal = Math.round(
				config.xp * multiplier
			);

			data.xp += xpFinal;

			const yutokensGanados =
				correcta === true
					? 12
					: correcta === false
					? 4
					: 2;

			data.yutokens =
				(data.yutokens || 0) +
				yutokensGanados;
			const ranked =
				calcularRanked({
					lpActual:
						data.rankedLp || 0,

					rangoActual:
						data.rankedRango ||
						"Hierro",

					resultado: correcta
				});

			data.rankedLp =
				ranked.lp;

			data.rankedRango =
				ranked.rango;
		
		if (!data.materiasStats) {
		
			data.materiasStats = {};
		}
		
		if (!data.materiasStats[materia]) {
		
			data.materiasStats[materia] = {
				correctas: 0,
				incorrectas: 0,
				noEntendidas: 0
			};
		}
		
		if (correcta === true) {
		
			data.materiasStats[materia].correctas += 1;
		
		} else if (correcta === false) {
		
			data.materiasStats[materia].incorrectas += 1;
		
		} else {
		
			data.materiasStats[materia].noEntendidas += 1;
		}			
	
		const precision =
			(data.preguntas_correctas /
				data.preguntas_respondidas) * 100;

				const componenteId =

    Number(metaId);

				let subioNivel = false;

				while (data.xp >= data.xp_siguiente_nivel) {
				
					data.xp -= data.xp_siguiente_nivel;
				
					data.nivel += 1;
				
					subioNivel = true;
				
					data.xp_siguiente_nivel =
						calcularXpNecesaria(data.nivel);
				}
				
				data.rango = calcularRango(data.nivel);
				
				data.corrupcion = Math.max(
					0,
					(data.corrupcion || 0) +
					config.corrupcion
				);

				const questsCompletadas = [];

				for (const quest of DAILY_QUESTS) {
				
					if (!data.dailyQuests) {
						data.dailyQuests = {};
					}
				
					if (!data.dailyQuests[quest.id]) {
				
						data.dailyQuests[quest.id] = {
							progreso: 0,
							completada: false
						};
					}
				
					const q = data.dailyQuests[quest.id];
				
					if (q.completada) continue;
				
					// =====================
					// PROGRESO
					// =====================
				
					if (quest.tipo === "preguntas") {
				
						q.progreso += 1;
					}
				
					if (quest.tipo === "xp") {
				
						q.progreso += config.xp;
					}
				
					if (quest.tipo === "streak") {
				
						q.progreso =
							data.streak_actual;
					}
				
					// =====================
					// COMPLETAR
					// =====================
				
					if (q.progreso >= quest.objetivo) {
				
						q.completada = true;
				
						data.xp += quest.recompensaXp;
				
						questsCompletadas.push({
							titulo: quest.titulo,
							xp: quest.recompensaXp
						});
					}
				}

				const nuevosAchievements = [];

				for (const achievement of ACHIEVEMENTS) {
				
					const yaExiste =
						data.achievements?.includes(
							achievement.id
						);
				
					if (yaExiste) continue;
				
					const desbloqueado =
						achievement.condicion(data);
				
					if (desbloqueado) {
				
						data.achievements = [
							...(data.achievements || []),
							achievement.id
						];
				
						nuevosAchievements.push({
							id: achievement.id,
							titulo: achievement.titulo,
							icono: achievement.icono,
							descripcion:
								achievement.descripcion
						});
					}
				}

				const evaluacionTema =

await actualizarProgresoTemas({

    userId,

    correcta,

    pregunta: {

        ...pregunta,

        componenteId:

            pregunta.componenteId ??

            Number(metaId)

    }

});
				
		await setDoc(ref, data);
		return {

			evaluacionTema,
		
			xpFinal,
		
			yutokens: data.yutokens,
		
			rankedLp: data.rankedLp,
		
			rankedRango: data.rankedRango,
		
			multiplier,
		
			xpActual: data.xp,
		
			xpMax: data.xp_siguiente_nivel,
		
			xpGanada: config.xp,
		
			subioNivel,
		
			nuevoNivel: data.nivel,
		
			nuevoRango: data.rango,
		
			streak: data.streak_actual,
		
			corrupcion: data.corrupcion,
		
			achievements: nuevosAchievements,
		
			dailyQuests: questsCompletadas,
		
			tipo:
				correcta === true
					? "correcta"
					: correcta === false
					? "incorrecta"
					: "noEntiendo"
		};
	} catch (error) {

		console.error(
			"ERROR actualizarProgresoMeta:"
		);
	
		console.error(error);
	
		console.error(
			"STACK:",
			error?.stack
		);
	
		return null;
	}
};

export default actualizarProgresoMeta;